import { Box, Grid } from '@mui/material';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Step1Basic from './Step1Basic';
import Step1Address from './Step1Address';
import { Step1FormType, Step1Schema } from '../schema';
const Step1 = () => {
  const methods = useForm<Step1FormType>({
    resolver: zodResolver(Step1Schema),
    mode: 'onChange',
  });

  const onSubmit = methods.handleSubmit((values) => {
    console.log('STEP-1 VALUES:', values);
  });
  return (
    <Grid
      container
      direction="column"
      sx={{
        padding: {
          xs: '20px 20px',
        },
      }}
    >
      <FormProvider {...methods}>
        <form onSubmit={onSubmit}>
          <Grid item>
            <Step1Basic />
          </Grid>
          <Grid item>
            <Step1Address />
          </Grid>
        </form>
      </FormProvider>
    </Grid>
  );
};

export default Step1;
